module.exports = __webpack_public_path__ + "img/2.69ad1e3e.jpeg";